/* src/app/modules/invoice/invoice/irpf-list.component.css */
.ef-page {
  padding: 24px;
  margin: 0 auto;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #f9ffe0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  color: var(--cf-brand-dark);
  font-size: 22px;
}
.ef-header__title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
}
.ef-header__sub {
  font-size: 13px;
  color: #6b7280;
  margin: 2px 0 0;
}
.ef-header__controls {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.trimester-select {
  width: 180px;
}
.ef-btn-save {
  background: #e3fd64;
  color: #1a1a1a;
  height: 40px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  gap: 6px;
}
.ef-btn-save mat-icon {
  font-size: 18px;
}
.ef-btn-save:disabled {
  background: #e0e0e0;
  color: #9e9e9e;
}
.ef-loading {
  display: flex;
  justify-content: center;
  padding: 60px 0;
}
.lf-box {
  text-align: center;
}
.lf-icon mat-icon {
  font-size: 40px;
  color: #e3fd64;
  opacity: 0.5;
}
.lf-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 12px 0;
}
.lf-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e3fd64;
  animation: bounce 1.2s infinite ease-in-out;
}
.lf-dots span:nth-child(1) {
  animation-delay: 0s;
}
.lf-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.lf-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
.lf-text {
  font-size: 13px;
  color: #9e9e9e;
  margin: 0;
}
.ef-summary-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.ef-card {
  flex: 1;
  min-width: 140px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ef-card--highlight {
  border-color: #f4fec1;
  background: #f9ffe0;
}
.ef-card__label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.ef-card__value {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
}
.ef-card--highlight .ef-card__value {
  color: #4d7a00;
}
.ef-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}
.ef-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  color: #9e9e9e;
  gap: 12px;
}
.ef-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.3;
}
.ef-empty p {
  font-size: 14px;
  margin: 0;
}
.no-pdf {
  color: #9e9e9e;
  cursor: default;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}
.no-pdf mat-icon {
  font-size: 14px;
}
/*# sourceMappingURL=irpf-list.component.css.map */
